"use strict";

exports.__esModule = true;
exports.AlertDefinitionContext = void 0;
var _Utils = require("../../../Utils");
var _AlertDefinitionController = require("./AlertDefinitionController");
var AlertDefinitionContext = exports.AlertDefinitionContext = (0, _Utils.createEnhancedContext)({
  propName: "alert",
  defaultController: _AlertDefinitionController.AlertDefinitionController
});